<template>
  <div class="asc-custom-alerts-configuration--wrapper">
    <div class="alertNameWrapper">
      <asc-text-field-input
        v-model="alertName"
        label="Analytic Name"
        :max-length="500"
        @blur="handleBlurAlertName"
      />
      <asc-accent-button
        v-if="activateEnabled"
        :outline="true"
        :secondary="true"
        :block="true"
        icon-position="left"
        icon="mdi-plus-circle-multiple-outline"
        button-text="DUPLICATE THIS ANALYTIC"
        :on-click="duplicateAlert"
      ></asc-accent-button>
    </div>
    <asc-accent-button
      v-if="showAddParameter"
      :outline="true"
      :secondary="true"
      :block="true"
      button-text="Add Parameter"
      :on-click="handleAddParameterClick"
    ></asc-accent-button>
    <div v-if="showConfiguration" class="configurations">
      <asc-tab :v-model="0">
        <asc-tab-title
          class="asc-customAlerts-configuration--parameterNameTab"
          :icon-right="true"
          icon="mdi-close"
          :title="parameterName"
          @iconClick="handleRemoveParameterClick"
        />
      </asc-tab>
      <asc-tab-body :value="0">
        <asc-tab-item>
          <v-row no-gutters>
            <v-col>
              <asc-subtitle
                value="Configurations"
                uppercase
                class="configurationSubtitle"
              ></asc-subtitle>
              <p>{{ getConfigurationSubTitle }}.</p>
              <div
                :class="[
                  'configurationSelectorWrapper',
                  alertType === 'acmf'
                    ? 'snapshotConfigurations'
                    : 'fullFlightConfigurations',
                ]"
              >
                <div class="persistenceWrapper">
                  <asc-label
                    :input-label="true"
                    value="Persistence Logic - Flights"
                  ></asc-label>
                  <div class="persistanceWrapper">
                    <asc-autocomplete-selector
                      v-model="persistenceFrom"
                      no-array
                      :label="`persistenceFrom`"
                      :items="getFlightPersistenceItems"
                    ></asc-autocomplete-selector>
                    <span> of </span>
                    <asc-autocomplete-selector
                      v-model="persistenceTo"
                      no-array
                      :label="`persistenceTo`"
                      :items="getFlightPersistenceItems"
                    ></asc-autocomplete-selector>
                    <p
                      v-if="!persistenceInvalid"
                      class="persistenceDescription"
                    >
                      {{ getPersistanceMessage }}
                    </p>
                    <asc-validation-message
                      v-if="persistenceInvalid"
                      message="Please enter
                      valid persistence logic, e.g. 1 of 2: Your analytic will trigger if a parameter threshold is met on 1 out of past 2 flights."
                      :show="true"
                    />
                  </div>
                </div>
                <div class="tailWrapper">
                  <asc-autocomplete-selector
                    id="tail"
                    v-model="tailIds"
                    class="tailSelector"
                    placeholder="Select a Tail"
                    label="Tails"
                    use-array
                    component-type="multiple"
                    :items="getTails"
                    :display-error-message="true"
                    validation-error-message="Please select an aircraft."
                  ></asc-autocomplete-selector>
                  <asc-autocomplete-selector
                    v-if="alertType === 'fullflight'"
                    id="flightPhase"
                    v-model="flightPhase"
                    placeholder="Select a Flight Phase"
                    label="Flight Phase"
                    use-array
                    class="flightPhaseSelector"
                    component-type="multiple"
                    :sort-items="false"
                    :items="getFlightPhases"
                    :display-error-message="true"
                    validation-error-message="Please select a flight phase."
                    @input="handleChangeFlightPhase"
                  ></asc-autocomplete-selector>
                </div>
              </div>
            </v-col>
          </v-row>
        </asc-tab-item>
      </asc-tab-body>
    </div>
    <asc-accent-button
      v-if="showConfiguration && !showHistogram"
      :outline="true"
      :secondary="true"
      :block="true"
      button-text="Continue to Next Step"
      :on-click="showHistogramClick"
    ></asc-accent-button>
  </div>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscLabel from '@/components/atoms/AscLabel.vue'
import AscSubtitle from '@/components/atoms/AscSubtitle'
import AscTab from '@/components/atoms/AscTab'
import AscTabBody from '@/components/atoms/AscTabBody'
import AscTabItem from '@/components/atoms/AscTabItem'
import AscTabTitle from '@/components/atoms/AscTabTitle'
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'
import AscValidationMessage from '@/components/atoms/AscValidationMessage'
import AscAutocompleteSelector from '@/components/molecules/AscAutocompleteSelector'
import _ from 'lodash'

export default {
  name: 'AscCustomAlertsConfigurationWrapper',

  components: {
    AscValidationMessage,
    AscTextFieldInput,
    AscAccentButton,
    AscTabBody,
    AscTabTitle,
    AscTabItem,
    AscTab,
    AscSubtitle,
    AscLabel,
    AscAutocompleteSelector,
  },

  props: {
    alertData: {
      type: Object,
      default: () => {},
    },
    flightPhases: {
      type: Array,
      default: () => [],
    },
    alertType: {
      type: String,
      default: undefined,
    },
    showConfiguration: {
      type: Boolean,
      default: false,
    },
    showAddParameter: {
      type: Boolean,
      default: true,
    },
    showHistogram: {
      type: Boolean,
      default: false,
    },
    activateEnabled: {
      type: Boolean,
      default: false,
    },
    parameterTailList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      numberOfFlightPersistance: [
        { text: '1', value: 1 },
        { text: '2', value: 2 },
        { text: '3', value: 3 },
        { text: '4', value: 4 },
        { text: '5', value: 5 },
        { text: '6', value: 6 },
        { text: '7', value: 7 },
        { text: '8', value: 8 },
        { text: '9', value: 9 },
        { text: '10', value: 10 },
      ],
      persistenceInvalid: false,
    }
  },

  computed: {
    getFlightPersistenceItems() {
      const numberofFlights = 10
      const itemArray = []
      for (let i = 1; i <= numberofFlights; i++) {
        itemArray.push({
          text: i < 10 ? `  ${i}` : `${i}`,
          value: i,
        })
      }
      return itemArray
    },
    getTails() {
      return this.parameterTailList
    },
    getFlightPhases() {
      return this.flightPhases
    },
    getConfigurationSubTitle() {
      if (this.alertType === 'acmf') {
        return 'Select Persistence Logic and Tails for your custom analytic'
      } else {
        return 'Select Persistence Logic, Tails, and Flight Phases for your custom analytic'
      }
    },
    getPersistanceMessage() {
      if (this.persistenceTo === 1 && this.persistenceTo === 1) {
        return 'Your analytic will trigger if a parameter threshold is met on a single flight'
      } else {
        return `Your analytic will trigger if a parameter threshold is met on ${this.persistenceFrom} out of ${this.persistenceTo} flights`
      }
    },
    persistenceFrom: {
      get() {
        return this.alertData?.persistenceFrom
      },
      set(val) {
        if (val > this.persistenceTo) {
          this.persistenceInvalid = true
        } else {
          this.persistenceInvalid = false
        }
        this.$emit('handleChangePersistenceFrom', val)
        if (this.persistenceInvalid) {
          this.$emit('invalidPersistence')
        } else {
          this.$emit('validPersistence')
        }
      },
    },
    persistenceTo: {
      get() {
        return this.alertData?.persistenceTo
      },
      set(val) {
        if (val < this.persistenceFrom) {
          this.persistenceInvalid = true
        } else {
          this.persistenceInvalid = false
        }
        this.$emit('handleChangePersistenceTo', val)
        if (this.persistenceInvalid) {
          this.$emit('invalidPersistence')
        } else {
          this.$emit('validPersistence')
        }
      },
    },
    parameterName: {
      get() {
        return this.alertData?.parameterName
      },
    },
    tailIds: {
      get() {
        return this.alertData?.tails
      },
      set(val) {
        this.$emit('handleChangeTails', val)
      },
    },
    flightPhase: {
      get() {
        return this.alertData?.flightPhase
      },
      set(id) {
        this.$emit('handleChangeFlightPhase', id)
      },
    },
    alertName: {
      get() {
        return this.alertData?.name
      },
      set(value) {
        this.handleUpdateAlertName(value)
      },
    },
  },
  watch: {
    alertData: {
      deep: true,
      async handler() {
        if (
          this.alertData.persistenceFrom > this.alertData.persistenceTo ||
          this.alertData.persistenceTo < this.alertData.persistenceFrom
        ) {
          this.persistenceInvalid = true
          this.$emit('invalidPersistence')
        } else {
          this.persistenceInvalid = false
          this.$emit('validPersistence')
        }
      },
    },
  },

  methods: {
    handleAddParameterClick() {
      this.$emit('handleAddParameter')
    },
    handleChangePersistenceFrom(value) {
      this.$emit('handleChangePersistenceFrom', value)
    },
    handleChangePersistenceTo(value) {
      this.$emit('handleChangePersistenceTo', value)
    },
    showHistogramClick() {
      this.$emit('showHistogram')
    },
    handleRemoveParameterClick() {
      this.$emit('handleRemoveParameter')
    },
    handleUpdateAlertName(value) {
      this.$emit('handleUpdateAlertName', value)
    },
    handleChangeFlightPhase(id) {
      const dropdownPhases = [...id]
      const alertPhases = [...this.alertData.flightPhase]
      if (dropdownPhases.length === 0) {
        this.$emit('clearHistogramData')
      } else {
        if (!_.isEqual(dropdownPhases.sort(), alertPhases.sort())) {
          this.$emit('handleUpdateFlightPhase', id)
        }
      }
    },
    duplicateAlert() {
      this.$emit('handleDuplicateAlert')
    },
    handleBlurAlertName(value) {
      if (!value) {
        value =
          this.alertType === 'acmf'
            ? 'ACMF Data Analytic'
            : 'Full Flight Data Analytic'
      }
      this.alertName = value
    },
  },
}
</script>

<style lang="scss">
.asc-custom-alerts-configuration--wrapper {
  margin-top: 20px;

  .asc-customAlerts-configuration--parameterNameTab {
    span {
      display: inline-block;
      padding-right: 10px;
    }

    .v-tab {
      max-width: initial;
    }
  }

  .alertNameWrapper {
    display: flex;
    align-items: center;

    .asc-input-field--container {
      flex: 3;
      margin-right: 20px;
    }

    .asc-accent-button-container {
      margin-top: 0;
    }
  }

  .configurations {
    margin-top: 20px;

    .configurationSubtitle {
      margin-bottom: 20px;

      .asc-header--h3 {
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 1px;
        font-weight: 500;
      }
    }

    .configurationSelectorWrapper {
      margin-bottom: 20px;

      .persistanceWrapper {
        display: flex;
        align-items: baseline;
        padding-top: 8px;
        margin-bottom: 10px;

        .asc-validation-message {
          font-size: 14px;
          margin-left: 8px;
        }

        .persistenceDescription {
          font-size: 14px;
          margin: 0 0 0 8px;
        }
      }

      .tailWrapper {
        display: flex;

        .flightPhaseSelector {
          margin-left: 20px;
        }
      }

      &.fullFlightConfigurations {
        > div {
          flex: none;
        }
      }

      > div {
        margin-right: 20px;
      }

      .tailSelector {
        flex: none;
      }

      .flightPhaseSelector,
      .tailSelector {
        flex: 1;
      }

      .asc-label {
        font-size: 12px;
        color: $gray-700;
      }

      .persistanceWrapper {
        display: flex;
        align-items: center;

        .asc-autocomplete-selector {
          width: 100px;
          margin-top: -3px;
        }

        .asc-base-selector--label {
          display: none;
        }

        span {
          display: inline-block;
          margin: 0 15px;
        }
      }
    }
  }
}
</style>
